(function () {
  // モーダルを body 直下に移動して、各セクションの stacking context（z-index: 3）から脱出させる。
  // これで他セクションが後ろに重なってもモーダルが必ず最前面に来る。
  function relocateModals() {
    document.querySelectorAll('.volca-discovery__modal').forEach(function (modal) {
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateModals);
  } else {
    relocateModals();
  }

  function openModal(id) {
    var modal = document.getElementById('modal-' + id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    // 背景スクロール禁止。scrollbar 消失による右ズレは CSS の scrollbar-gutter: stable が吸収。
    document.body.style.overflow = 'hidden';
    // 動画 iframe があれば lazy で src 注入（autoplay 付きの URL で再生開始）
    modal.querySelectorAll('iframe[data-src]').forEach(function (iframe) {
      if (!iframe.getAttribute('src')) iframe.setAttribute('src', iframe.dataset.src);
    });
  }

  function closeModal(id) {
    var modal = document.getElementById('modal-' + id);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    // 動画 iframe があれば src を消す＝再生停止（音残り防止）
    modal.querySelectorAll('iframe[data-src]').forEach(function (iframe) {
      iframe.removeAttribute('src');
    });
    var anyOpen = document.querySelector('.volca-discovery__modal.is-open');
    if (!anyOpen) document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openTarget = e.target.closest('[data-modal-open]');
    if (openTarget) {
      openModal(openTarget.dataset.modalOpen);
      return;
    }
    var closeTarget = e.target.closest('[data-modal-close]');
    if (closeTarget) {
      closeModal(closeTarget.dataset.modalClose);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.volca-discovery__modal.is-open').forEach(function (modal) {
        var id = modal.id.replace('modal-', '');
        closeModal(id);
      });
    }
  });
})();
